export const Title = ({ title }: { title: string }) => {
  return (
    <h1 className="title" style={{ marginTop: '0', marginBottom: '0' }}>
      {title}
    </h1>
  );
};
